import Blue from '~/core';
import Swiper, { Pagination } from 'swiper';

new Blue({
  name: 'FeatureBlockGallery',
  selector: '.feature-block--gallery ',
  setup(block) {
    const slider = block.querySelector('.feature-block__slider');
    const thumbs = block.querySelector('.feature-block__thumbs');

    initSlider();

    function initSlider() {
      let container = slider.querySelector('.feature-block__slider-container');
      let wrapper = slider.querySelector('.feature-block__slider-wrapper');
      let slides = [...slider.querySelectorAll('.feature-block__slider-slide')];
      container.classList.add('swiper-container');
      wrapper.classList.add('swiper-wrapper');
      slides.forEach(i => {
        i.classList.add('swiper-slide');
      });

      new Swiper(container, {
        modules: [Pagination],
        spaceBetween: 10,
        pagination: {
          el: thumbs,
          type: 'bullets',
          clickable: true,
          renderBullet(i, className) {
            let firstSource = slides[i].querySelector('picture > source');
            let imageSrc = '';
            if(!firstSource) {
              imageSrc = slides[i].querySelector('img').getAttribute('src');
            }
			else{
			  imageSrc = firstSource.getAttribute('srcset');	
			}
            

            return `
              <div class="feature-block__thumbs-slide ${className}" tabindex="0">
                <img class="feature-block__image" src="${imageSrc}" />
              </div>`;
          },
        },
      });
    }
  },
});
new Blue({
	name: 'Modal Trigger',
	selector: ".feature-block--gallery",
	setup(fbmodal) {
		const modalTrigger = fbmodal.querySelector('.feature-block__modal-trigger')
		const modalDialog = fbmodal.querySelector('.dialog-modal');
		if(modalTrigger){
			this.$addEvents(modalTrigger, 'click enter', () => {
				modalDialog.show();
			});
		}
	}
});